import type { FileDocumentKind } from './types.js';

const EXT_MAP: Record<string, FileDocumentKind> = {
  pdf: 'pdf',
  doc: 'word',
  docx: 'word',
  odt: 'word',
  xls: 'excel',
  xlsx: 'excel',
  csv: 'excel',
  ppt: 'presentation',
  pptx: 'presentation',
  zip: 'archive',
  rar: 'archive',
  '7z': 'archive',
  txt: 'text',
  md: 'text',
  json: 'text',
  xml: 'text',
};

export function getExtension(fileNameOrUrl: string): string {
  const clean = fileNameOrUrl.split('?')[0]?.split('#')[0] ?? '';
  const base = clean.split('/').pop() ?? clean;
  const dot = base.lastIndexOf('.');
  if (dot < 0) return '';
  return base.slice(dot + 1).toLowerCase();
}

export function getFileDocumentKind(
  fileNameOrUrl: string,
  mimeType?: string,
): FileDocumentKind {
  const mime = mimeType?.toLowerCase() ?? '';
  if (mime.includes('pdf')) return 'pdf';
  if (mime.includes('word') || mime.includes('msword')) return 'word';
  if (mime.includes('excel') || mime.includes('spreadsheet')) return 'excel';
  if (mime.includes('presentation') || mime.includes('powerpoint')) {
    return 'presentation';
  }
  if (mime.includes('zip') || mime.includes('archive')) return 'archive';
  if (mime.startsWith('text/')) return 'text';

  const ext = getExtension(fileNameOrUrl);
  return EXT_MAP[ext] ?? 'generic';
}

export function guessFileNameFromUrl(url: string): string {
  try {
    const pathname = new URL(url).pathname;
    const segment = pathname.split('/').filter(Boolean).pop();
    if (segment) return decodeURIComponent(segment);
  } catch {
    // ignore
  }
  return 'download';
}
